import { useWebsiteSettings } from 'client/store'
import {
  getWebsiteDraftTheme,
  getWebsiteStyles,
  getWebsiteTheme,
} from 'src/editor/store/website-settings/website-settings-selector'
import { useTransformWebsiteSettingsForSave } from './build-website-settings-for-save'

export const useWebsiteSettingsForSave = () => {
  const websiteStyles = useWebsiteSettings(getWebsiteStyles)
  const websiteDraftTheme = useWebsiteSettings(getWebsiteDraftTheme)
  const websiteTheme = useWebsiteSettings(getWebsiteTheme)

  return useTransformWebsiteSettingsForSave({
    websiteStyles,
    websiteTheme: websiteDraftTheme ?? websiteTheme,
  })
}
